import { getFirstVariantId } from '../utils/getProductJSON.js';
import { notifyHandledException } from '../utils/errorLogger';
import { updateCheckoutButton } from '../utils/buildCheckoutPermalink.js';

export const generatePetSelectorInputFragments = ({
  sample,
  petName,
  isSelected,
}) => {
  const fragment = document.createDocumentFragment();

  const input = document.createElement('input');
  input.id = sample;
  input.type = 'checkbox';
  input.name = 'checkBox';
  input.classList.add('pet-select-checkbox');
  input.value = sample;
  input.checked = !!isSelected;

  const label = document.createElement('label');
  label.classList.add('pet-select-checkbox-label');
  label.setAttribute('for', sample);

  const span = document.createElement('span');
  span.classList.add('pet-select-checkbox-inner');
  span.innerHTML = petName;

  label.appendChild(span);
  fragment.append(input, label);

  return fragment;
};

export const getSelectedPetsList = (
  scopeElement = false,
  selector = 'input:checked'
) => {
  const scope = scopeElement || document;

  const selectedPets = scope.querySelectorAll(selector);

  const petIdentifiers = [];

  for (const pet of selectedPets.values()) {
    if (pet.value != null) {
      petIdentifiers.push(pet.value);
    }
  }
  return petIdentifiers;
};

const updatePrice = (scopeElement = false, numberOfSwabCodes = 1) => {
  const scope = scopeElement || document;
  const multiplyPriceBySelectedPets = (price) => {
    const selectedPetsCount = numberOfSwabCodes || 1;
    return Math.floor(selectedPetsCount * price);
  };

  const regularUnitPriceElement = scope.querySelector('[data-regular-price]');

  if (regularUnitPriceElement) {
    const regularUnitPrice = regularUnitPriceElement.dataset.regularPrice;

    regularUnitPriceElement.innerHTML = `${window.Shopify.formatMoney(
      multiplyPriceBySelectedPets(regularUnitPrice),
      theme.moneyFormat
    )}`;
  }

  const saleUnitPriceDisplayElement = scope.querySelector('[data-sale-price]');
  if (saleUnitPriceDisplayElement) {
    const saleUnitPrice = saleUnitPriceDisplayElement.dataset.salePrice;
    saleUnitPriceDisplayElement.innerHTML = `${Shopify.formatMoney(
      multiplyPriceBySelectedPets(saleUnitPrice),
      theme.moneyFormat
    )}`;
  }
};

export const drawUpgradeablePetsForm = async (containerElement) => {
  const featuresTitle = document.querySelector('.upg-features-title');

  if (featuresTitle) {
    featuresTitle.innerHTML = 'Your dog will receive...';
  }

  return containerElement;
};

export default async function initUpgradeablePetsModule() {
  const ctaContainer = document.getElementById('cta-upgrade-pets');
  const variantId = getFirstVariantId();

  const errorMessage =
    'This product is for customers who have already purchased a Breed ID Test. Please log in to <a href="https://app.embarkvet.com/sign-in">your account</a> to select your dog’s profile for the upgrade.';

  if (!ctaContainer || variantId < 1) {
    return;
  }

  if (ctaContainer.classList.contains('initialized')) {
    return;
  }

  ctaContainer.classList.add('initialized');

  try {
    const upgradeablePetsContainer = await drawUpgradeablePetsForm(
      ctaContainer
    );

    const url = new URL(window.location.href);

    if (!url.searchParams.has('swabCode')) {
      document.body.classList.add('no-upgradeable-pets');
      throw new Error(errorMessage);
    }

    const petIdentifiers = url.searchParams.get('swabCode').split(',');

    if (!petIdentifiers || petIdentifiers.length < 1) {
      throw new Error(errorMessage);
    }

    document.body.classList.remove('no-upgradeable-pets');

    updateCheckoutButton(
      petIdentifiers,
      'a.upg-checkout-button',
      upgradeablePetsContainer
    );
    updatePrice(upgradeablePetsContainer, petIdentifiers.length || 1);
  } catch (error) {
    const errorBox = ctaContainer.querySelector('div.error-container');
    errorBox.insertAdjacentHTML(
      'beforeend',
      `<p class="error-container__message">${error.message}</p>`
    );
    notifyHandledException(error);
  }
}
